import { render, staticRenderFns } from "./AccidentEntityDetails.vue?vue&type=template&id=70f9d9e0&"
import script from "./AccidentEntityDetails.vue?vue&type=script&lang=js&"
export * from "./AccidentEntityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f9d9e0')) {
      api.createRecord('70f9d9e0', component.options)
    } else {
      api.reload('70f9d9e0', component.options)
    }
    module.hot.accept("./AccidentEntityDetails.vue?vue&type=template&id=70f9d9e0&", function () {
      api.rerender('70f9d9e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AccidentEntityDetails.vue"
export default component.exports